function isMultipleInput({ state, input, output }) {
  let field = state.get(input.field)
  if (field.isMultiple) {
    output.true()
  } else {
    output.false()
  }
}

isMultipleInput.outputs = ['true', 'false']
export default isMultipleInput



// WEBPACK FOOTER //
// ./src/modules/client/actions/isMultipleInput.js